<h1 mat-dialog-title class="text-center">
  <!-- <fa-icon class="faIcon" icon="calendar-alt"></fa-icon> -->
  <span>{{ 'k003847' | translate }}</span>
  <!-- Token: Customized report -->
  <div mat-button mat-dialog-close class="btoCLoseModal"><span>×</span></div>
</h1>
<div mat-dialog-content>
  <p class="parrafReport">{{ 'k003848' | translate }} </p> <!-- Token: Please choose the date range to generate the report. -->

  <div class="tech-form-standar">
    <mat-form-field  class="col-xs-12 col-lg-12">
      <mat-select
        class="tech-mat-selectCampaign"
        (selectionChange)="onPeriodChange($event)"
        [(value)]="selectedPeriod"
        [formControl]="periodForm">
        <mat-option
          *ngFor="let periodItem of arrperiods"
          [value]="periodItem.Period">
          {{ periodItem.Name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="col-xs-12 col-lg-6" *ngIf="showDatePickers">
      <mat-label>{{ 'k000388' | translate }}  </mat-label
      ><!-- Token: Inicial Date -->
      <input
        matInput
        (dateChange)="addDate('initialDate', $event)"
        [matDatepicker]="dpInicial"
        [min]="minDate"
        [max]="endDate"
        [formControl]="initialDateForm"
      />
      <mat-datepicker-toggle matSuffix [for]="dpInicial">
        <mat-icon matDatepickerToggleIcon>
          <fa-icon [icon]="['fal', 'calendar']" > </fa-icon>
        </mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #dpInicial></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="col-xs-12 col-lg-6" *ngIf="showDatePickers">
      <mat-label>{{ 'k000500' | translate }} </mat-label
      ><!-- Token: End Date: -->
      <input
        matInput
        (dateChange)="addDate('endDate', $event)"
        [matDatepicker]="dpEnd"
        [min]="initialDate"
        [max]="maxDate"
        [formControl]="endDateForm"
      />
      <mat-datepicker-toggle matSuffix [for]="dpEnd">
        <mat-icon matDatepickerToggleIcon>
          <fa-icon [icon]="['fal', 'calendar']" > </fa-icon>
      </mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #dpEnd></mat-datepicker>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="buttonPortal cancel mb-3">
    {{ 'k002311' | translate }} <!-- Token: cancel -->
  </button>
  <button
    class="buttonPortal mb-3 ml-2"
    mat-button
    cdkFocusInitial
    [disabled]="disableConfirm"
    [mat-dialog-close]="{ initialDate: initialDate, endDate: endDate }"
  >
  {{ 'k003849' | translate }}  <!-- Token: Create my report -->
  </button>
</div>
